import React from 'react';
import { ArcDroneMarker } from '@src/core/controllers';
import { DroneMarkersListProps } from './types';

/**
 * Component to render list of drone markers (idle and flying drones)
 * Handles both idle and mission drone markers with rotation support
 */
export const DroneMarkersList: React.FC<DroneMarkersListProps> = React.memo(({
  idleDrones,
  flyingDrones,
  clickedDrone,
  hoveredDrone,
  rotations,
  onDroneClick,
}) => {
  return (
    <>
      {idleDrones.map((drone) => {
        const isClicked = drone.serialNumber === clickedDrone?.serialNumber;
        const isHovered = drone.serialNumber === hoveredDrone?.serialNumber;
        
        // Show selected marker if clicked, otherwise show hovered if hovered, otherwise show normal
        if (isClicked || isHovered) {
          return (
            <ArcDroneMarker.idleSelected
              key={drone.id}
              position={{ lat: Number(drone.latitude), lng: Number(drone.longitude) }}
              onClick={() => onDroneClick(drone)}
            />
          );
        }
        
        return (
          <ArcDroneMarker.idleArrow
            key={drone.id}
            position={{
              lat: Number(drone.latitude),
              lng: Number(drone.longitude),
            }}
            onClick={() => onDroneClick(drone)}
          />
        );
      })}
      {flyingDrones.map((drone) => {
        const rotation = rotations[drone.serialNumber] ?? 0;
        const isClicked = drone.serialNumber === clickedDrone?.serialNumber;
        const isHovered = drone.serialNumber === hoveredDrone?.serialNumber;

        // Show selected marker if clicked or hovered, otherwise show normal
        if (isClicked || isHovered) {
          return (
            <ArcDroneMarker.missionSelected
              key={drone.id}
              position={{ lat: Number(drone.latitude), lng: Number(drone.longitude) }}
              onClick={() => onDroneClick(drone)}
              rotation={rotation}
            />
          );
        }

        return (
          <ArcDroneMarker.missionArrow
            key={drone.id}
            position={{ lat: Number(drone.latitude), lng: Number(drone.longitude) }}
            rotation={rotation}
            onClick={() => onDroneClick(drone)}
          />
        );
      })}
    </>
  );
});

DroneMarkersList.displayName = 'DroneMarkersList';

